<div class="dialog-container">
  <div class="dialog-header">
    <h2 class="dialog-title">{{ 'fee.group_setup.edit_group_name' | translate }}</h2>
    <button class="close-btn" type="button" (click)="cancel()" [attr.aria-label]="'common.close_dialog' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <form [formGroup]="form" (ngSubmit)="save()" class="dialog-form">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'fee.group_name' | translate }}</mat-label>
      <input matInput formControlName="companyName" />
      @if (form.get('companyName')!.hasError('required') && form.get('companyName')!.touched) {
        <mat-error>{{ 'fee.validation.required' | translate }}</mat-error>
      }
      @if (form.get('companyName')!.hasError('maxlength')) {
        <mat-error>{{ 'fee.validation.max_25_characters' | translate }}</mat-error>
      }
    </mat-form-field>

    <div class="dialog-actions">
      <button class="btn-cancel" type="button" (click)="cancel()">{{ 'Cancel' | translate }}</button>
      <button class="btn-save" type="submit" [disabled]="form.invalid || saving">{{ 'user_card.save' | translate }}</button>
    </div>
  </form>
</div>
